<template>
    <Teleport to="body">
  
      <Transition name="ai-confirm">
  
        <div
          class="ai-confirm-overlay"
          @click.self="close"
        >
  
          <div
            class="ai-confirm-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="ai-confirm-title"
          >
  
            <!-- =================================================
                 CLOSE
            ================================================== -->
  
            <button
              type="button"
              class="ai-confirm-close"
              aria-label="Закрыть"
              @click="close"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 7L17 17"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
  
                <path
                  d="M17 7L7 17"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
              </svg>
            </button>
  
  
            <!-- =================================================
                 ICON
            ================================================== -->
  
            <div class="ai-confirm-icon">
  
              <div class="ai-confirm-icon-glow"></div>
  
              <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 3.5L13.7 8.3L18.5 10L13.7 11.7L12 16.5L10.3 11.7L5.5 10L10.3 8.3L12 3.5Z"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linejoin="round"
                />
  
                <path
                  d="M18.5 15L19.3 17.2L21.5 18L19.3 18.8L18.5 21L17.7 18.8L15.5 18L17.7 17.2L18.5 15Z"
                  stroke="currentColor"
                  stroke-width="1.4"
                  stroke-linejoin="round"
                />
  
                <path
                  d="M5 3L5.7 4.8L7.5 5.5L5.7 6.2L5 8L4.3 6.2L2.5 5.5L4.3 4.8L5 3Z"
                  stroke="currentColor"
                  stroke-width="1.3"
                  stroke-linejoin="round"
                />
              </svg>
  
            </div>
  
  
            <!-- =================================================
                 CONTENT
            ================================================== -->
  
            <div class="ai-confirm-content">
  
              <div class="ai-confirm-badge">
                AI помощник
              </div>
  
              <h2
                id="ai-confirm-title"
                class="ai-confirm-title"
              >
                Подготовить сопроводительное письмо?
              </h2>
  
              <p class="ai-confirm-description">
                AI подготовит персональное сопроводительное
                письмо на основе вашего профиля и информации
                о компании.
              </p>
  
  
              <!-- VACANCY -->
  
              <div
                v-if="vacancyTitle || companyName"
                class="ai-confirm-vacancy"
              >
  
                <div class="ai-confirm-vacancy-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      x="4"
                      y="6"
                      width="16"
                      height="14"
                      rx="3"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
  
                    <path
                      d="M9 6V5C9 3.9 9.9 3 11 3H13C14.1 3 15 3.9 15 5V6"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
  
                    <path
                      d="M4 11H20"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
  
                <div class="ai-confirm-vacancy-text">
  
                  <span
                    v-if="vacancyTitle"
                    class="ai-confirm-vacancy-title"
                  >
                    {{ vacancyTitle }}
                  </span>
  
                  <span
                    v-if="companyName"
                    class="ai-confirm-company"
                  >
                    {{ companyName }}
                  </span>
  
                </div>
  
              </div>
  
  
              <!-- INFO -->
  
              <div class="ai-confirm-note">
  
                <div class="ai-confirm-note-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
  
                    <path
                      d="M12 10V16"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                    />
  
                    <circle
                      cx="12"
                      cy="7.2"
                      r="0.9"
                      fill="currentColor"
                    />
                  </svg>
                </div>
  
                <span>
                  Письмо не будет отправлено автоматически.
                  Сначала вы сможете его проверить.
                </span>
  
              </div>
  
            </div>
  
  
            <!-- =================================================
                 ACTIONS
            ================================================== -->
  
            <div class="ai-confirm-actions">
  
              <button
                type="button"
                class="ai-confirm-button cancel"
                @click="close"
              >
                Отмена
              </button>
  
              <button
                type="button"
                class="ai-confirm-button confirm"
                @click="confirm"
              >
  
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 3.5L13.5 8.5L18.5 10L13.5 11.5L12 16.5L10.5 11.5L5.5 10L10.5 8.5L12 3.5Z"
                    stroke="currentColor"
                    stroke-width="1.6"
                    stroke-linejoin="round"
                  />
                </svg>
  
                <span>
                  Подготовить письмо
                </span>
  
              </button>
  
            </div>
  
          </div>
  
        </div>
  
      </Transition>
  
    </Teleport>
  </template>
  
  
  <script setup>
  
  import {
    onBeforeUnmount,
    onMounted
  } from "vue";
  
  
  defineProps({
  
    vacancyTitle: {
      type: String,
      default: ""
    },
  
    companyName: {
      type: String,
      default: ""
    }
  
  });
  
  
  const emit = defineEmits([
    "close",
    "confirm"
  ]);
  
  
  function close() {
    emit("close");
  }
  
  
  function confirm() {
    emit("confirm");
  }
  
  
  function handleKeyDown(event) {
  
    if (
      event.key === "Escape"
    ) {
  
      close();
  
    }
  
  }
  
  
  onMounted(
    () => {
  
      window.addEventListener(
        "keydown",
        handleKeyDown
      );
  
    }
  );
  
  
  onBeforeUnmount(
    () => {
  
      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
  
    }
  );
  
  </script>
  
  
  <style scoped>
  
  /* =========================================================
     OVERLAY
  ========================================================= */
  
  .ai-confirm-overlay {
    position:
      fixed;
  
    inset:
      0;
  
    z-index:
      100000;
  
    display:
      flex;
  
    align-items:
      center;
  
    justify-content:
      center;
  
    padding:
      20px;
  
    box-sizing:
      border-box;
  
    background:
      rgba(
        15,
        20,
        28,
        0.42
      );
  
    backdrop-filter:
      blur(8px);
  
    -webkit-backdrop-filter:
      blur(8px);
  }
  
  
  /* =========================================================
     MODAL
  ========================================================= */
  
  .ai-confirm-modal {
    position:
      relative;
  
    width:
      min(
        440px,
        calc(100vw - 32px)
      );
  
    overflow:
      hidden;
  
    background:
      rgba(
        255,
        255,
        255,
        0.98
      );
  
    border:
      1px solid
      rgba(
        30,
        45,
        65,
        0.08
      );
  
    border-radius:
      24px;
  
    box-shadow:
      0
      30px
      80px
      rgba(
        15,
        23,
        42,
        0.22
      );
  }
  
  
  /* =========================================================
     CLOSE
  ========================================================= */
  
  .ai-confirm-close {
    position:
      absolute;
  
    top:
      14px;
  
    right:
      14px;
  
    z-index:
      5;
  
    width:
      34px;
  
    height:
      34px;
  
    display:
      flex;
  
    align-items:
      center;
  
    justify-content:
      center;
  
    padding:
      0;
  
    color:
      #8b929b;
  
    background:
      rgba(
        40,
        50,
        65,
        0.045
      );
  
    border:
      0;
  
    border-radius:
      10px;
  
    cursor:
      pointer;
  
    transition:
      background-color 0.18s ease,
      color 0.18s ease,
      transform 0.18s ease;
  }
  
  
  .ai-confirm-close:hover {
    color:
      #4d5560;
  
    background:
      rgba(
        40,
        50,
        65,
        0.075
      );
  
    transform:
      rotate(3deg);
  }
  
  
  .ai-confirm-close svg {
    width:
      16px;
  
    height:
      16px;
  }
  
  
  /* =========================================================
     ICON
  ========================================================= */
  
  .ai-confirm-icon {
    position:
      relative;
  
    width:
      62px;
  
    height:
      62px;
  
    display:
      flex;
  
    align-items:
      center;
  
    justify-content:
      center;
  
    margin:
      34px
      auto
      20px;
  
    color:
      #ffffff;
  
    background:
      linear-gradient(
        135deg,
        #3b8cf5,
        #6d65ef 55%,
        #8d58d5
      );
  
    border-radius:
      20px;
  
    box-shadow:
      0
      14px
      30px
      rgba(
        85,
        102,
        225,
        0.26
      );
  }
  
  
  .ai-confirm-icon-glow {
    position:
      absolute;
  
    inset:
      -12px;
  
    z-index:
      -1;
  
    background:
      radial-gradient(
        circle,
        rgba(
          100,
          108,
          236,
          0.18
        ),
        transparent 70%
      );
  
    border-radius:
      50%;
  }
  
  
  .ai-confirm-icon svg {
    width:
      31px;
  
    height:
      31px;
  }
  
  
  /* =========================================================
     CONTENT
  ========================================================= */
  
  .ai-confirm-content {
    padding:
      0
      32px;
  }
  
  
  .ai-confirm-badge {
    width:
      fit-content;
  
    margin:
      0
      auto
      10px;
  
    padding:
      5px
      9px;
  
    color:
      #696bd5;
  
    background:
      rgba(
        93,
        101,
        221,
        0.075
      );
  
    border:
      1px solid
      rgba(
        93,
        101,
        221,
        0.09
      );
  
    border-radius:
      999px;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size:
      9px;
  
    letter-spacing:
      0.2px;
  
    text-transform:
      uppercase;
  }
  
  
  .ai-confirm-title {
    margin:
      0;
  
    color:
      #272c33;
  
    font-family:
      "Eastman-Bold",
      sans-serif;
  
    font-size:
      20px;
  
    line-height:
      1.25;
  
    letter-spacing:
      -0.4px;
  
    text-align:
      center;
  }
  
  
  .ai-confirm-description {
    max-width:
      350px;
  
    margin:
      11px
      auto
      0;
  
    color:
      #737b85;
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  
    font-size:
      12px;
  
    line-height:
      1.55;
  
    text-align:
      center;
  }
  
  
  /* =========================================================
     VACANCY
  ========================================================= */
  
  .ai-confirm-vacancy {
    display:
      flex;
  
    align-items:
      center;
  
    gap:
      11px;
  
    margin-top:
      22px;
  
    padding:
      12px
      13px;
  
    background:
      #f7f8fa;
  
    border:
      1px solid
      rgba(
        30,
        45,
        65,
        0.055
      );
  
    border-radius:
      13px;
  }
  
  
  .ai-confirm-vacancy-icon {
    width:
      36px;
  
    height:
      36px;
  
    flex:
      0
      0
      36px;
  
    display:
      flex;
  
    align-items:
      center;
  
    justify-content:
      center;
  
    color:
      #5a7eb0;
  
    background:
      #eef3f8;
  
    border-radius:
      10px;
  }
  
  
  .ai-confirm-vacancy-icon svg {
    width:
      18px;
  
    height:
      18px;
  }
  
  
  .ai-confirm-vacancy-text {
    min-width:
      0;
  
    display:
      flex;
  
    flex-direction:
      column;
  
    gap:
      3px;
  }
  
  
  .ai-confirm-vacancy-title {
    overflow:
      hidden;
  
    color:
      #3d444d;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size:
      11px;
  
    line-height:
      1.3;
  
    text-overflow:
      ellipsis;
  
    white-space:
      nowrap;
  }
  
  
  .ai-confirm-company {
    overflow:
      hidden;
  
    color:
      #8b929a;
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  
    font-size:
      9px;
  
    text-overflow:
      ellipsis;
  
    white-space:
      nowrap;
  }
  
  
  /* =========================================================
     NOTE
  ========================================================= */
  
  .ai-confirm-note {
    display:
      flex;
  
    align-items:
      flex-start;
  
    gap:
      8px;
  
    margin-top:
      11px;
  
    padding:
      10px
      11px;
  
    color:
      #777f89;
  
    background:
      rgba(
        56,
        126,
        221,
        0.045
      );
  
    border:
      1px solid
      rgba(
        56,
        126,
        221,
        0.07
      );
  
    border-radius:
      11px;
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  
    font-size:
      9px;
  
    line-height:
      1.45;
  }
  
  
  .ai-confirm-note-icon {
    width:
      15px;
  
    height:
      15px;
  
    flex:
      0
      0
      15px;
  
    color:
      #5980b5;
  }
  
  
  .ai-confirm-note-icon svg {
    width:
      15px;
  
    height:
      15px;
  }
  
  
  /* =========================================================
     ACTIONS
  ========================================================= */
  
  .ai-confirm-actions {
    display:
      flex;
  
    gap:
      9px;
  
    padding:
      22px
      32px
      30px;
  }
  
  
  .ai-confirm-button {
    height:
      42px;
  
    display:
      inline-flex;
  
    align-items:
      center;
  
    justify-content:
      center;
  
    gap:
      7px;
  
    padding:
      0
      18px;
  
    border-radius:
      12px;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size:
      11px;
  
    cursor:
      pointer;
  
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      box-shadow 0.18s ease,
      border-color 0.18s ease;
  }
  
  
  .ai-confirm-button.cancel {
    flex:
      0
      0
      105px;
  
    color:
      #68717c;
  
    background:
      #f5f6f8;
  
    border:
      1px solid
      rgba(
        35,
        50,
        70,
        0.06
      );
  }
  
  
  .ai-confirm-button.cancel:hover {
    background:
      #eef0f3;
  
    transform:
      translateY(-1px);
  }
  
  
  .ai-confirm-button.confirm {
    flex:
      1;
  
    color:
      #ffffff;
  
    background:
      linear-gradient(
        135deg,
        #3e8cf2,
        #4f72e6 54%,
        #755edb
      );
  
    border:
      0;
  
    box-shadow:
      0
      8px
      19px
      rgba(
        71,
        104,
        221,
        0.22
      );
  }
  
  
  .ai-confirm-button.confirm:hover {
    transform:
      translateY(-1px);
  
    box-shadow:
      0
      11px
      24px
      rgba(
        71,
        104,
        221,
        0.29
      );
  }
  
  
  .ai-confirm-button:active {
    transform:
      scale(0.98);
  }
  
  
  .ai-confirm-button.confirm svg {
    width:
      15px;
  
    height:
      15px;
  }
  
  
  /* =========================================================
     DARK
  ========================================================= */
  
  :global(html[data-theme="dark"])
  .ai-confirm-overlay {
    background:
      rgba(
        5,
        7,
        11,
        0.62
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-modal {
    background:
      linear-gradient(
        145deg,
        #24272d,
        #1d1f24
      );
  
    border-color:
      rgba(
        255,
        255,
        255,
        0.07
      );
  
    box-shadow:
      0
      30px
      90px
      rgba(
        0,
        0,
        0,
        0.46
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-title {
    color:
      #f1f2f4;
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-description {
    color:
      #969da6;
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-vacancy {
    background:
      rgba(
        255,
        255,
        255,
        0.035
      );
  
    border-color:
      rgba(
        255,
        255,
        255,
        0.05
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-vacancy-icon {
    color:
      #8aafe3;
  
    background:
      rgba(
        91,
        143,
        216,
        0.09
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-vacancy-title {
    color:
      #d8dbe0;
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-company {
    color:
      #777e87;
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-note {
    color:
      #858d97;
  
    background:
      rgba(
        81,
        133,
        207,
        0.055
      );
  
    border-color:
      rgba(
        81,
        133,
        207,
        0.08
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-close {
    color:
      #858c96;
  
    background:
      rgba(
        255,
        255,
        255,
        0.04
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-close:hover {
    color:
      #d1d4d8;
  
    background:
      rgba(
        255,
        255,
        255,
        0.065
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-button.cancel {
    color:
      #adb2b9;
  
    background:
      rgba(
        255,
        255,
        255,
        0.045
      );
  
    border-color:
      rgba(
        255,
        255,
        255,
        0.055
      );
  }
  
  
  :global(html[data-theme="dark"])
  .ai-confirm-button.cancel:hover {
    background:
      rgba(
        255,
        255,
        255,
        0.07
      );
  }
  
  
  /* =========================================================
     TRANSITION
  ========================================================= */
  
  .ai-confirm-enter-active,
  .ai-confirm-leave-active {
    transition:
      opacity 0.20s ease;
  }
  
  
  .ai-confirm-enter-active
  .ai-confirm-modal,
  .ai-confirm-leave-active
  .ai-confirm-modal {
    transition:
      opacity 0.22s ease,
      transform 0.24s
      cubic-bezier(
        0.2,
        0.8,
        0.3,
        1
      );
  }
  
  
  .ai-confirm-enter-from,
  .ai-confirm-leave-to {
    opacity:
      0;
  }
  
  
  .ai-confirm-enter-from
  .ai-confirm-modal {
    opacity:
      0;
  
    transform:
      translateY(12px)
      scale(0.975);
  }
  
  
  .ai-confirm-leave-to
  .ai-confirm-modal {
    opacity:
      0;
  
    transform:
      translateY(7px)
      scale(0.985);
  }
  
  
  /* =========================================================
     MOBILE
  ========================================================= */
  
  @media (max-width: 430px) {
  
    .ai-confirm-overlay {
      padding:
        14px;
    }
  
  
    .ai-confirm-modal {
      width:
        100%;
  
      border-radius:
        21px;
    }
  
  
    .ai-confirm-content {
      padding:
        0
        22px;
    }
  
  
    .ai-confirm-actions {
      padding:
        20px
        22px
        24px;
    }
  
  
    .ai-confirm-button.cancel {
      flex-basis:
        92px;
    }
  
  
    .ai-confirm-title {
      font-size:
        18px;
    }
  
  }

  /* =========================================================
   DARK THEME
========================================================= */

html[data-theme="dark"]
.ai-confirm-overlay {
  background:
    rgba(
      3,
      5,
      9,
      0.68
    );

  backdrop-filter:
    blur(10px);

  -webkit-backdrop-filter:
    blur(10px);
}


html[data-theme="dark"]
.ai-confirm-modal {
  background:
    linear-gradient(
      145deg,
      #22242a 0%,
      #1d1f24 100%
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );

  box-shadow:
    0
    32px
    90px
    rgba(
      0,
      0,
      0,
      0.52
    );
}


html[data-theme="dark"]
.ai-confirm-close {
  color:
    #858c96;

  background:
    rgba(
      255,
      255,
      255,
      0.045
    );
}


html[data-theme="dark"]
.ai-confirm-close:hover {
  color:
    #e0e2e5;

  background:
    rgba(
      255,
      255,
      255,
      0.075
    );
}


html[data-theme="dark"]
.ai-confirm-badge {
  color:
    #b4a0ef;

  background:
    rgba(
      118,
      91,
      214,
      0.11
    );

  border-color:
    rgba(
      151,
      121,
      228,
      0.13
    );
}


html[data-theme="dark"]
.ai-confirm-title {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.ai-confirm-description {
  color:
    #9299a3;
}


html[data-theme="dark"]
.ai-confirm-vacancy {
  background:
    rgba(
      255,
      255,
      255,
      0.035
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.ai-confirm-vacancy-icon {
  color:
    #8bafe2;

  background:
    rgba(
      83,
      137,
      211,
      0.10
    );
}


html[data-theme="dark"]
.ai-confirm-vacancy-title {
  color:
    #d9dce1;
}


html[data-theme="dark"]
.ai-confirm-company {
  color:
    #777e88;
}


html[data-theme="dark"]
.ai-confirm-note {
  color:
    #8d949e;

  background:
    rgba(
      75,
      125,
      202,
      0.06
    );

  border-color:
    rgba(
      91,
      143,
      215,
      0.09
    );
}


html[data-theme="dark"]
.ai-confirm-note-icon {
  color:
    #7da1d2;
}


html[data-theme="dark"]
.ai-confirm-button.cancel {
  color:
    #b0b5bc;

  background:
    rgba(
      255,
      255,
      255,
      0.045
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.06
    );
}


html[data-theme="dark"]
.ai-confirm-button.cancel:hover {
  color:
    #e0e2e5;

  background:
    rgba(
      255,
      255,
      255,
      0.075
    );
}


html[data-theme="dark"]
.ai-confirm-button.confirm {
  background:
    linear-gradient(
      135deg,
      #397fd2,
      #526bd2 52%,
      #7557c5
    );

  box-shadow:
    0
    9px
    22px
    rgba(
      63,
      84,
      190,
      0.26
    );
}


html[data-theme="dark"]
.ai-confirm-button.confirm:hover {
  box-shadow:
    0
    12px
    28px
    rgba(
      73,
      91,
      200,
      0.34
    );
}
  
  </style>